<div class="row">
  <div class="col s6 text-align-left">
    <a class="btn btn-outline" type="button" [routerLink]="url">
      Back to frame catalog
    </a>
  </div>
  <div class="col s6 text-align-right" *ngIf="!patientId">
    <button class="btn btn-outline" type="button" (click)="exportBrand()" [disabled]="isExportingBrand">
      Export Brand Assortment
      <fa-icon *ngIf="isExportingBrand" icon="spinner" [spin]="true"></fa-icon>
    </button>
  </div>
</div>
